import axios from "axios";

// In production (custom domain), use relative /api URLs to avoid CORS issues
// In development/preview, use the env variable
const isCustomDomain = typeof window !== 'undefined' && 
  !window.location.hostname.includes('emergentagent.com') && 
  !window.location.hostname.includes('localhost');

const BACKEND_URL = isCustomDomain ? '' : (process.env.REACT_APP_BACKEND_URL || '');
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const fetchLiveRaces = () => api.get("/races/live").then(r => r.data).catch(e => { console.error("Failed to fetch races:", e); return []; });

export const fetchHorses = (params) => api.get("/horses", { params }).then(r => r.data).catch(e => { console.error("Failed to fetch horses:", e); return { horses: [], total: 0 }; });

export const fetchHorse = (id) => api.get(`/horses/${id}`).then(r => r.data);

export const fetchTracks = () => api.get("/tracks").then(r => r.data).catch(() => []);

export const fetchTrack = (id) => api.get(`/tracks/${id}`).then(r => r.data);

export const fetchJockey = (id) => api.get(`/jockeys/${id}`).then(r => r.data);

export const searchAll = (q) => api.get("/search", { params: { q } }).then(r => r.data).catch(() => ({ horses: [], tracks: [], jockeys: [] }));

export const exportHorseCSV = (id) => `${API}/horses/${id}/export`;

export const fetchPredictionStats = () => api.get("/prediction-stats").then(r => r.data).catch(() => ({ total_finished: 0, correct: 0, wrong: 0, accuracy_pct: 0, top3_correct: 0, top3_pct: 0, results: [] }));

export const fetchDailyTips = () => api.get("/daily-tips").then(r => r.data).catch(() => ({ tips: [], total_races_analysed: 0 }));

export const fetchNews = () => api.get("/news").then(r => r.data).catch(() => ({ articles: [] }));

export const fetchRadioStreams = () => api.get("/radio-streams").then(r => r.data).catch(() => ({ streams: [] }));

export const loginUser = (email, password) => api.post("/auth/login", { email, password }).then(r => r.data);

export const registerUser = (email, password, name) => api.post("/auth/register", { email, password, name }).then(r => r.data);

export const logoutUser = () => api.post("/auth/logout").then(r => r.data);

export const getMe = () => api.get("/auth/me").then(r => r.data).catch(() => null);

export const getSubscriptionStatus = () => api.get("/subscription/status").then(r => r.data).catch(() => ({ active: false }));

export const createSubscriptionCheckout = (origin_url) => api.post("/subscription/checkout", { origin_url }).then(r => r.data);

export const verifySubscription = (session_id) => api.get(`/subscription/verify/${session_id}`).then(r => r.data);

export const cancelSubscription = () => api.post("/subscription/cancel").then(r => r.data);

export const getSubscriptionDetails = () => api.get("/subscription/details").then(r => r.data);

export const getNotificationPrefs = () => api.get("/notifications/preferences").then(r => r.data).catch(() => ({ daily_tips_email: false }));

export const updateNotificationPrefs = (prefs) => api.post("/notifications/preferences", prefs).then(r => r.data);

export default api;
